import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/abouts/About.vue"
import GradeList from "./views/grade/list.vue"
import AddGrade from "./views/grade/add.vue"
import AddQuestionType from "./views/questionType/add.vue"
import QuestionTypeList from "./views/questionType/list.vue"

import Login from "./views/login/login.vue";
import AddAnswerType from "./views/answerType/add.vue"
import AnswerTypeList from "./views/answerType/list.vue"

import QuestionAdd from "./views/question/add.vue"
import QuestionList from "./views/question/list.vue"
import QuestionUpda from "./views/question/upda.vue"

import UserList from "./views/user/list.vue"
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',

      component: Login
    },
    
      {
      path: "/",
      name: "等级和标签",
      children: [
      {
          path: '/grade/add',
          component: AddGrade,
          name:"新增标签",
         
        }  ,
       {
          path: '/grade/grade',
          component: GradeList,
          name:"标签列表",
         
        } 
      ] ,
      component:Home
    } ,{
      path: "/",
      name: "题型说明",
      children: [
      {
          path: '/questionType/add',
          component: AddQuestionType,
          name:"新增题型",
         
        }  ,
        {
          path: '/questionType/list',
          component: QuestionTypeList,
          name:"题型列表管理",
         
        }  
      ] ,
      component:Home
    }
    ,
    {
      path: "/",
      name: "题目管理",
      children: [
        {
          path: '/question/add',
          component: QuestionAdd,
          name:"新增题目",
         
        }  ,
         {
          path: '/question/list',
          component: QuestionList,
          name:"题目列表",
         
        } ,
        {
          path: '/question/upda',
          component: QuestionUpda,
          name:"word上传",
         
        }  
      ] ,
      component:Home
    } 
   
  ]
});
